export enum QuantityCode {
  OxygenRate = 'quantity.code.oxygenrate',
  ChargeItemConsumable = 'quantity.chargeitem.consumable',
}
